export default "__VITE_ASSET__a61fb474__"